import { components } from '@package/types/integrations/content/umbraco';
import { ConfigurationFlowProps } from '@/components/modules/configuration-flow/configuration-flow';

type ContentModuleWithType =
  ConfigurationFlowProps['steps'][0]['contentModules'][0] & { $type?: string };

export const isRoomMatrix = (
  item: ContentModuleWithType | undefined,
): item is components['schemas']['RoomMatrixHeadlessModuleDto'] => {
  return item?.$type === 'RoomMatrixHeadlessModuleDto';
};
